import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuthState } from '@/api/auth'
import { Button, EmptyState, PageSpinner } from '@/components/ui'
import { LockGate } from '@/lock/LockGate'

/**
 * Пропускает дальше только с сессией; до первичной настройки ведёт на /setup.
 * Заблокированное приложение (src/lock) вместо экранов показывает разблокировку.
 */
export function RequireAuth() {
  const location = useLocation()
  const state = useAuthState()

  if (state.isPending) return <PageSpinner />
  if (state.isError) {
    return (
      <EmptyState
        icon="wifi-off"
        title="Сервер не отвечает"
        description="Проверь связь и попробуй ещё раз."
        action={
          <Button variant="primary" onClick={() => void state.refetch()} loading={state.isFetching}>
            Повторить
          </Button>
        }
        className="min-h-dvh justify-center"
      />
    )
  }
  // Если экранов /setup и /login нет среди маршрутов, не уходим в бесконечный редирект.
  if (state.data.setup_required) {
    return location.pathname === '/setup' ? null : <Navigate to="/setup" replace />
  }
  if (!state.data.authenticated) {
    if (location.pathname === '/login') return null
    const next = location.pathname + location.search
    return <Navigate to={next === '/' ? '/login' : `/login?next=${encodeURIComponent(next)}`} replace />
  }
  return (
    <LockGate state={state.data}>
      <Outlet />
    </LockGate>
  )
}
